/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminBulkIndexActivityToElastic} from '../api'

export const useMutationAdminBulkIndexActivityToElastic = createReactQueryMutationHook('adminBulkIndexActivityToElastic', adminBulkIndexActivityToElastic)
